'use strict'; // Load modules

var _classCallCheck = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Hoek = require('hoek');

var ObjectType = require('../object');

var Ref = require('../../ref'); // Declare internals


var internals = {};

internals.Func = /*#__PURE__*/function (_ObjectType$construct) {
  _inherits(_class, _ObjectType$construct);

  var _super = _createSuper(_class);

  function _class() {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this);
    _this._flags.func = true;
    return _this;
  }

  _createClass(_class, [{
    key: "arity",
    value: function arity(n) {
      Hoek.assert(Number.isSafeInteger(n) && n >= 0, 'n must be a positive integer');
      return this._test('arity', n, function (value, state, options) {
        if (value.length === n) {
          return value;
        }

        return this.createError('function.arity', {
          n
        }, state, options);
      });
    }
  }, {
    key: "minArity",
    value: function minArity(n) {
      Hoek.assert(Number.isSafeInteger(n) && n > 0, 'n must be a strict positive integer');
      return this._test('minArity', n, function (value, state, options) {
        if (value.length >= n) {
          return value;
        }

        return this.createError('function.minArity', {
          n
        }, state, options);
      });
    }
  }, {
    key: "maxArity",
    value: function maxArity(n) {
      Hoek.assert(Number.isSafeInteger(n) && n >= 0, 'n must be a positive integer');
      return this._test('maxArity', n, function (value, state, options) {
        if (value.length <= n) {
          return value;
        }

        return this.createError('function.maxArity', {
          n
        }, state, options);
      });
    }
  }, {
    key: "ref",
    value: function ref() {
      return this._test('ref', null, function (value, state, options) {
        if (Ref.isRef(value)) {
          return value;
        }

        return this.createError('function.ref', {
          value
        }, state, options);
      });
    }
  }, {
    key: "class",
    value: function _class() {
      return this._test('class', null, function (value, state, options) {
        if (/^\s*class\s/.test(value.toString())) {
          return value;
        }

        return this.createError('function.class', {
          value
        }, state, options);
      });
    }
  }]);

  return _class;
}(ObjectType.constructor);

module.exports = new internals.Func();